import ACTIONS from '../actionTypes/apiDocs';

const initialState = {
  lastUpdatedTimestamp: null,
  entitylist: [],
  sideNavSections: [],
  loadedSwaggers: {},
  originalSchemas: {},
};

export default function apiDocs(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.SET_SIDENAV_SECTIONS: {
      return {
        ...state,
        sideNavSections: [...action.payload],
        lastUpdatedTimestamp: new Date().toISOString(),
      };
    }
    case ACTIONS.SET_ENTITY_LIST: {
      return {
        ...state,
        entitylist: [...action.payload],
        lastUpdatedTimestamp: new Date().toISOString(),
      };
    }
    case ACTIONS.SET_ORIGINAL_SCHEMAS: {
      return {
        ...state,
        originalSchemas: {
          ...state.originalSchemas,
          [action.payload.companyKey]: action.payload.data
        },
      };
    }
    case ACTIONS.ADD_LOADED_SWAGGER:
      return {
        ...state,
        loadedSwaggers: {
          ...state.loadedSwaggers,
          [action.payload.companyKey]: { 
            ...state.loadedSwaggers[action.payload.companyKey],
            [action.payload.swaggerKey]: { timestamp: new Date().toISOString(), data: action.payload.data, originalPathData: action.payload.originalPathData }
          },
        }
      };
    default:
      return state;
  }
}
